<template>
<div>
    <nav class="main-nav">
            <a class="logo" href="/">
                <img src="../../assets/logo.png">
            </a>
            <burger></burger>
        </nav>

        <Sidebar>
            <ul class="sidebar-panel-nav" @click="closeNavbar">
                <li><router-link to="/" class="logo-menu">
                    <img src="../../assets/logo_reverse.png">
                </router-link></li>
                <li><router-link to="/#news">nieuws</router-link></li>
                <li><router-link to="/#about">over ons</router-link></li>
                <li><router-link to="/#media">media</router-link></li>
                <li><router-link to="/#puppy">puppy</router-link></li>
                <li><router-link to="/#history">geschiedenis</router-link></li>
                <li><router-link to="/#contact">contact</router-link></li>
            </ul>
        </Sidebar>

    <div id="page-content" class="columns is-centered">
        <div class="column is-three-fifths">
            <slot></slot>
        </div>
    </div>
    <div id="contact" class="column contact is-centered">
        <contact></contact>
    </div>
    <div class="column footer">
        <div class="columns">
            <div class="column is-half">
                <p class="copy">© 2019 De Belgische Mastiff vzw</p>
            </div>
<!--
            <div class="column is-half">
                <a href="#" class="terms">Terms &amp; Conditions</a>
            </div>
-->
        </div>
    </div>
</div>
</template>

<script>
import Burger from '../Menu/Burger';
import Sidebar from '../Menu/Sidebar';
import Contact from '../Home/Contact';
import { store } from '@/store.js'
export default {
    name: "ArticleLayout",
    components: {
        Burger, Sidebar, Contact
    },
    methods: {
      closeNavbar: function() {
        store.isNavOpen = false;
      }
    }
}
</script>

<style scoped>
    .contact {
        margin-top: 10vh;
        padding-top: 10vh;
        background: #99C5C4;
    }

    .footer {
        margin: 0;
        padding: 1em;
        background-color: #99C5C4;
    }

    .copy {
        color: #006f70;
        font-weight: 300;
    }

    .terms {
        color: #006f70;
        font-weight: 300;
        position: absolute;
        right: 1vw;
        transition: color .3s ease;
    }

    .terms:hover {
        color: #fff;
    }
    
    .subpage-top {
        margin-top: 4vh;
        display: flex;
        margin-bottom: 0;
        justify-content: space-between;
        align-items: center;
        flex-flow: row wrap;
    }
    
    h1 {
        color: #016F70;
        font-weight: bold;
        line-height: 2;
        font-size: 2.8em;  
    }
    
    .subpage-top a {
        position: relative;
        font-size: 1.1em;
        font-weight: 500;
        color: #016F70;
        padding-bottom: 2px;
        transition: color .3s ease, border .3s ease;
    }
    
    .subpage-top a:before {
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: #016F70;
        visibility: hidden;
        transition: all 0.3s ease-in-out;
    }
    
    .subpage-top a:hover:before {
        visibility: visible;
        width: 100%;
    }
    
    .subpage-top a:hover {
        color: #016F70;
    }
    
    @media screen and (max-width: 768px) {
        .contact {
            padding-top: 10vw;
            margin-top: 0;
        }
        h1 {
            font-size: 2em;
        }
    }
</style>